import { Link } from "react-router-dom";

interface PromoBannerProps {
  imageUrl: string;
  text: string | null;
  link: string | null;
}

export function PromoBanner({ imageUrl, text, link }: PromoBannerProps) {
  const content = (
    <div className="relative h-full rounded-2xl overflow-hidden">
      <img src={imageUrl} alt={text ?? "Promotion"} className="w-full h-full object-cover" loading="lazy" />
      {text && (
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent flex items-end p-6 sm:p-8">
          <p className="text-white text-lg sm:text-2xl font-serif tracking-tight">{text}</p>
        </div>
      )}
    </div>
  );

  return (
    <section className="max-w-7xl mx-auto px-6 pt-12">
      <div className="aspect-[21/9] sm:aspect-[21/6]">
        {link ? (
          link.startsWith("/") ? (
            <Link to={link} className="block h-full">
              {content}
            </Link>
          ) : (
            <a href={link} target="_blank" rel="noreferrer" className="block h-full">
              {content}
            </a>
          )
        ) : (
          content
        )}
      </div>
    </section>
  );
}
